import BaseClass from "../BaseClass";

export default class DropdownAdjuster extends BaseClass {

    constructor(element) {
        super(element);

        this.dropdownElement = null;
        this.decreaseElementListener = null;
        this.decreaseElement = null;
        this.increaseElementListener = null;
        this.increaseElement = null;

        this.init();
    }

    init() {
        let mySelf = this;

        const dropdownElement = this.$element.find('[data-type="dropdown"]');
        if (1 == dropdownElement.length) {
            this.dropdownElement = $(dropdownElement[0]);

            const decreaseElement = this.$element.find('[data-type="decrease"]');
            if (1 == decreaseElement.length) {
                this.decreaseElement = decreaseElement;
                this.decreaseElementListener = function (event) {
                    mySelf.decrease(event);
                }
                this.decreaseElement.on('click', this.decreaseElementListener);
            }

            const increaseElement = this.$element.find('[data-type="increase"]');
            if (1 == increaseElement.length) {
                this.increaseElement = increaseElement;
                this.increaseElementListener = function (event) {
                    mySelf.increase(event);
                }
                this.increaseElement.on('click', this.increaseElementListener);
            }
        }
    }

    decrease(event) {
        event.preventDefault();

        if (this.dropdownElement[0].selectedIndex > 0) {
            this.dropdownElement[0].selectedIndex--;
            this.dropdownElement.trigger('change');
        }
    }

    increase(event) {
        event.preventDefault();

        if ((this.dropdownElement[0].selectedIndex + 1) < this.dropdownElement[0].length) {
            this.dropdownElement[0].selectedIndex++;
            this.dropdownElement.trigger('change');
        }
    }

    destroyListener() {
        if (this.decreaseElementListener != null) {
            this.decreaseElement.off('click', this.decreaseElementListener);
        }

        if (this.increaseElementListener != null) {
            this.increaseElement.off('click', this.increaseElementListener);
        }
    }
}